// extracted by mini-css-extract-plugin
export default {"popoverPaper":"RelationsPopover_popoverPaper__F5MD1","header":"RelationsPopover_header__2bk2F","backdrop":"RelationsPopover_backdrop__HigYI"};